namespace TabAurous.OMS {
    export interface PaymentModeRow {
        ModeId?: number;
        Type?: number;
        FixedName?: string;
        Code?: string;
        Name?: string;
        LedgerId?: number;
        LedgerName?: string;
        CommissionPercent?: number;
        CommissionAccount?: number;
        OnlyForPos?: boolean;
        IsDisabled?: boolean;
        AllowSelection?: boolean;
        Num1?: number;
        Num2?: number;
        String1?: string;
        String2?: string;
        SysDate?: string;
    }

    export namespace PaymentModeRow {
        export const idProperty = 'ModeId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'OMS.PaymentMode';
        export const lookupKey = 'OMS.PaymentMode';

        export function getLookup(): Q.Lookup<PaymentModeRow> {
            return Q.getLookup<PaymentModeRow>('OMS.PaymentMode');
        }
        export const deletePermission = 'Masters:PaymentMode:Delete';
        export const insertPermission = 'Masters:PaymentMode:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:PaymentMode:Edit';

        export declare const enum Fields {
            ModeId = "ModeId",
            Type = "Type",
            FixedName = "FixedName",
            Code = "Code",
            Name = "Name",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            CommissionPercent = "CommissionPercent",
            CommissionAccount = "CommissionAccount",
            OnlyForPos = "OnlyForPos",
            IsDisabled = "IsDisabled",
            AllowSelection = "AllowSelection",
            Num1 = "Num1",
            Num2 = "Num2",
            String1 = "String1",
            String2 = "String2",
            SysDate = "SysDate"
        }
    }
}
